/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-page.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '../shared/meta.service';
import * as import5 from '../shared/content.service';
import * as import6 from '@angular/core/src/linker/view_utils';
import * as import7 from '@angular/core/src/di/injector';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/change_detection';
import * as import10 from '../../angular2-meta';
import * as import11 from '@angular/http/src/http';
import * as import12 from '@angular/router/src/router';
import * as import13 from '../shared/config.service';
import * as import14 from '../shared/intl.service';
import * as import15 from '../shared/utils.service';
import * as import16 from '@angular/router/src/router_state';
import * as import17 from '@angular/core/src/metadata/view';
import * as import18 from '@angular/core/src/linker/component_factory';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '../shared/intl.pipe';
import * as import21 from '@angular/core/src/linker/template_ref';
import * as import22 from '@angular/common/src/directives/ng_if';
import * as import23 from '../shared/loading-indicator.ngfactory';
import * as import24 from '../shared/loading-indicator';
import * as import25 from '@angular/core/src/security';
export class Wrapper_ContentPageComponent {
  context:import0.ContentPageComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.ContentPageComponent(p0,p1,p2,p3,p4,p5);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentPageComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentPageComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _MetaService_0_4:import4.MetaService;
  _ContentService_0_5:import5.ContentService;
  _ContentPageComponent_0_6:Wrapper_ContentPageComponent;
  constructor(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageComponent_Host0,renderType_ContentPageComponent_Host,import8.ViewType.HOST,viewUtils,parentInjector,declarationEl,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import6.selectOrCreateRenderHostElement(this.renderer,'ng-component',import6.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentPageComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._MetaService_0_4 = new import4.MetaService(this.parentInjector.get(import10.Meta));
    this._ContentService_0_5 = new import5.ContentService(this.parentInjector.get(import11.Http),this.parentInjector.get(import12.Router));
    this._ContentPageComponent_0_6 = new Wrapper_ContentPageComponent(this.parentInjector.get(import13.ConfigService),this.parentInjector.get(import14.IntlService),this.parentInjector.get(import15.UtilsService),this._MetaService_0_4,this._ContentService_0_5,this.parentInjector.get(import16.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentPageComponent_0_6.context,([] as any[]),compView_0);
    compView_0.create(this._ContentPageComponent_0_6.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.MetaService) && (0 === requestNodeIndex))) { return this._MetaService_0_4; }
    if (((token === import5.ContentService) && (0 === requestNodeIndex))) { return this._ContentService_0_5; }
    if (((token === import0.ContentPageComponent) && (0 === requestNodeIndex))) { return this._ContentPageComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentPageComponent_0_6.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentPageComponent_0_6.context.ngAfterContentChecked(); }
    this._ContentPageComponent_0_6.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPageComponent_Host0(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentPageComponent_Host === (null as any))) { (renderType_ContentPageComponent_Host = viewUtils.createRenderComponentType('',0,import17.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentPageComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentPageComponentNgFactory:import18.ComponentFactory<import0.ContentPageComponent> = new import18.ComponentFactory<import0.ContentPageComponent>('ng-component',viewFactory_ContentPageComponent_Host0,import0.ContentPageComponent);
const styles_ContentPageComponent:any[] = ([] as any[]);
var renderType_ContentPageComponent:import2.RenderComponentType = (null as any);
class _View_ContentPageComponent0 extends import1.AppView<import0.ContentPageComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import19.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _appEl_9:import3.AppElement;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import19.Wrapper_NgIf;
  _text_10:any;
  _text_11:any;
  _anchor_12:any;
  /*private*/ _appEl_12:import3.AppElement;
  _TemplateRef_12_5:any;
  _NgIf_12_6:import19.Wrapper_NgIf;
  _pipe_intl_0:import20.IntlPipe;
  constructor(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageComponent0,renderType_ContentPageComponent,import8.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import6.createRenderElement(this.renderer,parentRenderNode,'section',new import6.InlineArray2(2,'class','page-title-pull-top page-title parallax3 parallax-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import6.createRenderElement(this.renderer,this._el_0,'div',new import6.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_6 = new import3.AppElement(6,(null as any),this,this._anchor_6);
    this._TemplateRef_6_5 = new import21.TemplateRef_(this._appEl_6,viewFactory_ContentPageComponent1);
    this._NgIf_6_6 = new import19.Wrapper_NgIf(this._appEl_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_8 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_9 = new import3.AppElement(9,(null as any),this,this._anchor_9);
    this._TemplateRef_9_5 = new import21.TemplateRef_(this._appEl_9,viewFactory_ContentPageComponent3);
    this._NgIf_9_6 = new import19.Wrapper_NgIf(this._appEl_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_11 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._anchor_12 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_12 = new import3.AppElement(12,(null as any),this,this._anchor_12);
    this._TemplateRef_12_5 = new import21.TemplateRef_(this._appEl_12,viewFactory_ContentPageComponent4);
    this._NgIf_12_6 = new import19.Wrapper_NgIf(this._appEl_12.vcRef,this._TemplateRef_12_5);
    this._pipe_intl_0 = new import20.IntlPipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._anchor_12
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import22.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import21.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import22.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import21.TemplateRef) && (12 === requestNodeIndex))) { return this._TemplateRef_12_5; }
    if (((token === import22.NgIf) && (12 === requestNodeIndex))) { return this._NgIf_12_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_6_0_0:any = (this.context.content && this.context.currentLanguage);
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    const currVal_9_0_0:any = this.context.loading;
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.detectChangesInInputProps(this,this._anchor_9,throwOnChange);
    const currVal_12_0_0:any = (this.context.content && this.context.currentLanguage);
    this._NgIf_12_6.check_ngIf(currVal_12_0_0,throwOnChange,false);
    this._NgIf_12_6.detectChangesInInputProps(this,this._anchor_12,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentPageComponent0(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentPageComponent> {
  if ((renderType_ContentPageComponent === (null as any))) { (renderType_ContentPageComponent = viewUtils.createRenderComponentType('',0,import17.ViewEncapsulation.None,styles_ContentPageComponent,{})); }
  return new _View_ContentPageComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgIf_15_6:import19.Wrapper_NgIf;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  /*private*/ _expr_22:any;
  constructor(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageComponent1,renderType_ContentPageComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_22 = import9.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import6.createRenderElement(this.renderer,(null as any),'section',new import6.InlineArray2(2,'class','page-title page-title-small bg-gray'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import6.createRenderElement(this.renderer,this._el_0,'div',new import6.InlineArray2(2,'class','container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import6.createRenderElement(this.renderer,this._el_2,'div',new import6.InlineArray2(2,'class','row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import6.createRenderElement(this.renderer,this._el_4,'div',new import6.InlineArray2(2,'class','col-md-4 col-sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._text_8 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_9 = import6.createRenderElement(this.renderer,this._el_6,'h1',new import6.InlineArray2(2,'class','black-text'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._appEl_15 = new import3.AppElement(15,4,this,this._anchor_15);
    this._TemplateRef_15_5 = new import21.TemplateRef_(this._appEl_15,viewFactory_ContentPageComponent2);
    this._NgIf_15_6 = new import19.Wrapper_NgIf(this._appEl_15.vcRef,this._TemplateRef_15_5);
    this._text_16 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_0,'\n',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._text_18
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import21.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import22.NgIf) && (15 === requestNodeIndex))) { return this._NgIf_15_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_15_0_0:any = (this.parent.context.content.url == 'about');
    this._NgIf_15_6.check_ngIf(currVal_15_0_0,throwOnChange,false);
    this._NgIf_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_22:any = import6.interpolate(1,'',this.parent.context.content.title[this.parent.context.currentLanguage],'');
    if (import6.checkBinding(throwOnChange,this._expr_22,currVal_22)) {
      this.renderer.setText(this._text_10,currVal_22);
      this._expr_22 = currVal_22;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPageComponent1(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  /*private*/ _expr_22:any;
  _pipe_intl_0_0:any;
  /*private*/ _expr_24:any;
  _pipe_intl_0_1:any;
  /*private*/ _expr_26:any;
  _pipe_intl_0_2:any;
  /*private*/ _expr_28:any;
  _pipe_intl_0_3:any;
  constructor(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageComponent2,renderType_ContentPageComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_22 = import9.UNINITIALIZED;
    this._expr_24 = import9.UNINITIALIZED;
    this._expr_26 = import9.UNINITIALIZED;
    this._expr_28 = import9.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import6.createRenderElement(this.renderer,(null as any),'div',new import6.InlineArray2(2,'class','col-md-8 col-sm-12 breadcrumb text-uppercase'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_3 = import6.createRenderElement(this.renderer,this._el_0,'ul',new import6.InlineArray2(2,'class','breadcrumb-sub'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                        ',(null as any));
    this._el_5 = import6.createRenderElement(this.renderer,this._el_3,'li',import6.EMPTY_INLINE_ARRAY,(null as any));
    this._el_6 = import6.createRenderElement(this.renderer,this._el_5,'a',new import6.InlineArray2(2,'class','breadcrumb-active'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_3,'\n                        ',(null as any));
    this._el_9 = import6.createRenderElement(this.renderer,this._el_3,'li',import6.EMPTY_INLINE_ARRAY,(null as any));
    this._el_10 = import6.createRenderElement(this.renderer,this._el_9,'a',new import6.InlineArray2(2,'class','pointer'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_3,'\n                        ',(null as any));
    this._el_13 = import6.createRenderElement(this.renderer,this._el_3,'li',import6.EMPTY_INLINE_ARRAY,(null as any));
    this._el_14 = import6.createRenderElement(this.renderer,this._el_13,'a',new import6.InlineArray2(2,'class','pointer'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_3,'\n                            ',(null as any));
    this._el_17 = import6.createRenderElement(this.renderer,this._el_3,'li',import6.EMPTY_INLINE_ARRAY,(null as any));
    this._el_18 = import6.createRenderElement(this.renderer,this._el_17,'a',new import6.InlineArray2(2,'class','pointer'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._text_21 = this.renderer.createText(this._el_0,'\n\n                ',(null as any));
    this._pipe_intl_0_0 = import6.pureProxy2((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0));
    var disposable_0:Function = this.renderer.listen(this._el_10,'click',this.eventHandler(this._handle_click_10_0.bind(this)));
    this._pipe_intl_0_1 = import6.pureProxy2((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0));
    var disposable_1:Function = this.renderer.listen(this._el_14,'click',this.eventHandler(this._handle_click_14_0.bind(this)));
    this._pipe_intl_0_2 = import6.pureProxy2((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0));
    var disposable_2:Function = this.renderer.listen(this._el_18,'click',this.eventHandler(this._handle_click_18_0.bind(this)));
    this._pipe_intl_0_3 = import6.pureProxy2((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._text_21
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import9.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_22:any = import6.interpolate(1,'\n                            ',valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_0,(<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.PRESENTATION),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange,this._expr_22,currVal_22))) {
      this.renderer.setText(this._text_7,currVal_22);
      this._expr_22 = currVal_22;
    }
    valUnwrapper.reset();
    const currVal_24:any = import6.interpolate(1,'\n                            ',valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_1,(<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.PRESS),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange,this._expr_24,currVal_24))) {
      this.renderer.setText(this._text_11,currVal_24);
      this._expr_24 = currVal_24;
    }
    valUnwrapper.reset();
    const currVal_26:any = import6.interpolate(1,'\n                            ',valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_2,(<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.PARTNERS),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_15,currVal_26);
      this._expr_26 = currVal_26;
    }
    valUnwrapper.reset();
    const currVal_28:any = import6.interpolate(1,'\n                            ',valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_3,(<_View_ContentPageComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.CONTACT),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_19,currVal_28);
      this._expr_28 = currVal_28;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_10_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_10_0:any = ((<any>this.parent.parent.context.utils.scrollToClass('press',(0 - 100))) !== false);
    return (true && pd_10_0);
  }
  private _handle_click_14_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_14_0:any = ((<any>this.parent.parent.context.utils.scrollToClass('partners',0)) !== false);
    return (true && pd_14_0);
  }
  private _handle_click_18_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_18_0:any = ((<any>this.parent.parent.context.utils.scrollToClass('contact',0)) !== false);
    return (true && pd_18_0);
  }
}
function viewFactory_ContentPageComponent2(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _LoadingIndicator_6_4:import23.Wrapper_LoadingIndicator;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  constructor(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageComponent3,renderType_ContentPageComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import6.createRenderElement(this.renderer,(null as any),'section',import6.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import6.createRenderElement(this.renderer,this._el_0,'div',new import6.InlineArray2(2,'class','container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import6.createRenderElement(this.renderer,this._el_2,'div',new import6.InlineArray2(2,'class','row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import6.createRenderElement(this.renderer,this._el_4,'loading-indicator',new import6.InlineArray2(2,'color','#B6B6B6'),(null as any));
    this._appEl_6 = new import3.AppElement(6,4,this,this._el_6);
    var compView_6:any = import23.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(6),this._appEl_6);
    this._LoadingIndicator_6_4 = new import23.Wrapper_LoadingIndicator();
    this._appEl_6.initComponent(this._LoadingIndicator_6_4.context,([] as any[]),compView_6);
    compView_6.create(this._LoadingIndicator_6_4.context,([] as any[]),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'  \n        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.LoadingIndicator) && (6 === requestNodeIndex))) { return this._LoadingIndicator_6_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_6_0_0:any = '#B6B6B6';
    this._LoadingIndicator_6_4.check_color(currVal_6_0_0,throwOnChange,false);
    this._LoadingIndicator_6_4.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_6_4.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPageComponent3(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentPageComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentPageComponent4,renderType_ContentPageComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import9.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import6.createRenderElement(this.renderer,(null as any),'div',new import6.InlineArray2(2,'class','page-content'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = this.parent.context.content.content[this.parent.context.currentLanguage];
    if (import6.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setElementProperty(this._el_0,'innerHTML',this.viewUtils.sanitizer.sanitize(import25.SecurityContext.HTML,currVal_2));
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentPageComponent4(viewUtils:import6.ViewUtils,parentInjector:import7.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentPageComponent4(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-page.component.ngfactory.ts